module.exports = __webpack_public_path__ + "static/media/doc-1.1ac13629.svg";